export enum DynamicSlotName {
  START = 'start',
  END = 'end',

  BLOCKS_START = 'blocks_start',
  BLOCKS_END = 'blocks_end',

  CREDIT_CARD_FORM_START = 'credit_card_form_start',
  CREDIT_CARD_FORM_END = 'credit_card_form_end',

  PURPOSES_START = 'purposes_start',
  PURPOSES_END = 'purposes_end',

  AMOUNTS_START = 'amounts_start',
  AMOUNTS_END = 'amounts_end',

  CURRENCIES_START = 'currencies_start',
  CURRENCIES_END = 'currencies_end',

  PAYMENT_TYPES_START = 'payment_types_start',
  PAYMENT_TYPES_END = 'payment_types_end',

  RECURRING_INTERVALS_START = 'recurring_intervals_start',
  RECURRING_INTERVALS_END = 'recurring_intervals_end',

  DIRECT_DEBIT_FORM_START = 'direct_debit_form_start',
  DIRECT_DEBIT_FORM_1 = 'direct_debit_form_1',
  DIRECT_DEBIT_FORM_END = 'direct_debit_form_end',

  ELEKTRONISCHES_LASTSCHRIFTVERFAHREN_FORM_START = 'elektronisches_lastschriftverfahren_form_start',
  ELEKTRONISCHES_LASTSCHRIFTVERFAHREN_FORM_END = 'elektronisches_lastschriftverfahren_form_end',

  SEPA_ONE_FORM_START = 'sepa_one_form_start',
  SEPA_ONE_FORM_1 = 'sepa_one_form_1',
  SEPA_ONE_FORM_END = 'sepa_one_form_end',

  PAYMENT_SLIP_FORM_START = 'payment_slip_form_start',
  PAYMENT_SLIP_FORM_END = 'payment_slip_form_end',

  PAYMENT_SLIP_WITH_REFERENCE_NUMBER_FORM_START = 'payment_slip_with_reference_number_form_start',
  PAYMENT_SLIP_WITH_REFERENCE_NUMBER_FORM_END = 'payment_slip_with_reference_number_form_end',

  POST_FINANCE_FORM_START = 'post_finance_form_start',
  POST_FINANCE_FORM_END = 'post_finance_form_end',

  SMS_FORM_START = 'sms_form_start',
  SMS_FORM_END = 'sms_form_end',

  PROFILE_FORM_START = 'profile_form_start',
  PROFILE_FORM_1 = 'profile_form_1',
  PROFILE_FORM_2 = 'profile_form_2',
  PROFILE_FORM_3 = 'profile_form_3',
  PROFILE_FORM_4 = 'profile_form_4',
  PROFILE_FORM_5 = 'profile_form_5',
  PROFILE_FORM_6 = 'profile_form_6',
  PROFILE_FORM_7 = 'profile_form_7',
  PROFILE_FORM_END = 'profile_form_end',

  ADDRESS_FORM_START = 'address_form_start',
  ADDRESS_FORM_1 = 'address_form_1',
  ADDRESS_FORM_2 = 'address_form_2',
  ADDRESS_FORM_3 = 'address_form_3',
  ADDRESS_FORM_4 = 'address_form_4',
  ADDRESS_FORM_5 = 'address_form_5',
  ADDRESS_FORM_6 = 'address_form_6',
  ADDRESS_FORM_7 = 'address_form_7',
  ADDRESS_FORM_END = 'address_form_end',

  COVER_FEE_START = 'cover_fee_start',
  COVER_FEE_END = 'cover_fee_end',

  TRANSACTION_INFO_START = 'transaction_info_start',
  TRANSACTION_INFO_1 = 'transaction_info_1',
  TRANSACTION_INFO_2 = 'transaction_info_2',
  TRANSACTION_INFO_END = 'transaction_info_end',

  SUBSCRIPTION_INFO_START = 'subscription_info_start',
  SUBSCRIPTION_INFO_1 = 'subscription_info_1',
  SUBSCRIPTION_INFO_2 = 'subscription_info_2',
  SUBSCRIPTION_INFO_END = 'subscription_info_end',

  EPMS_PAYMENT_INFO_START = 'epms_payment_info_start',
  EPMS_PAYMENT_INFO_1 = 'epms_payment_info_1',
  EPMS_PAYMENT_INFO_2 = 'epms_payment_info_2',
  EPMS_PAYMENT_INFO_END = 'epms_payment_info_end',

  EPMS_SUBSCRIPTION_INFO_START = 'epms_subscription_info_start',
  EPMS_SUBSCRIPTION_INFO_1 = 'epms_subscription_info_1',
  EPMS_SUBSCRIPTION_INFO_2 = 'epms_subscription_info_2',
  EPMS_SUBSCRIPTION_INFO_END = 'epms_subscription_info_end',

  SUBSCRIPTION_CANCEL_START = 'subscription_cancel_start',
  SUBSCRIPTION_CANCEL_END = 'subscription_cancel_end',

  SUBSCRIPTION_CANCELLED_START = 'subscription_cancelled_start',
  SUBSCRIPTION_CANCELLED_END = 'subscription_cancelled_end',

  FAQ_START = 'faq_start',
  FAQ_END = 'faq_end',

  SUBSCRIPTION_PAYMENT_METHOD_UPDATED_START = 'subscription_payment_method_updated_start',
  SUBSCRIPTION_PAYMENT_METHOD_UPDATED_END = 'subscription_payment_method_updated_end',
}
